export default {
    API_ENDPOINT: 'https://blooming-ocean-81879.herokuapp.com/api',
    TOKEN_KEY: 'a-token-goes-here',
    API_KEY: process.env.REACT_APP_API_KEY || '5ecb6ba7-e3fe-4b62-b17f-f5957f550b42', 
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL ||
    "http://localhost:3000/api"
  }